import { useCallback } from 'react'
import Group from 'components/utils/Group'
import Modal from 'LuxKit/Modal/Modal'
import useModalElementContext from 'hooks/Modal/useModalElementContext'
import BodyText from 'LuxKit/Typography/BodyText'
import { useIntl } from 'react-intl'

interface Props {
  isInfiniteTier: boolean
}

function LoyaltyReopenAccountConfirmationModal({ isInfiniteTier }: Props) {
  const modalElement = useModalElementContext<boolean>()
  const intl = useIntl()

  const confirm = useCallback(() => {
    modalElement.resolve(true)
  }, [modalElement])

  const cancel = useCallback(() => {
    modalElement.resolve(false)
  }, [modalElement])

  const infiniteTitle = intl.formatMessage({
    id: 'Hs8zKIUgTuXhsvea6EtA',
    defaultMessage: 'Reopen your Infinite account?',
    description: 'Title of the modal asking an Infinite member to confirm reopening their closed Infinite account',
  })

  const societeTitle = intl.formatMessage({
    id: 'xnajeXC2UYtos6-2p5LF',
    defaultMessage: 'Reopen your Société account?',
    description: 'Title of the modal asking a customer to confirm reopening their closed Société account',
  })

  const infiniteBody = intl.formatMessage({
    id: 'F21r3Y_SeJ0BDJXvtfGv',
    defaultMessage: 'You’ll get access to your points again, earn on every booking and enjoy your Infinite benefits on every escape.',
    description: 'Body of the modal asking an Infinite member to confirm reopening their closed Infinite account',
  })

  const societeBody = intl.formatMessage({
    id: 'vL6qtXPm5RGzpLps9F99',
    defaultMessage: 'You’ll get access to your points again, earn on every booking and enjoy your Société benefits on every escape.',
    description: 'Body of the modal asking a customer to confirm reopening their closed Société account',
  })

  const title = isInfiniteTier ? infiniteTitle : societeTitle
  const body = isInfiniteTier ? infiniteBody : societeBody

  const closeAgainNote = intl.formatMessage({
    id: 'wVEj1EWmYphszhgkXQbB',
    defaultMessage: 'To close your account again in the future, you’ll need to contact our Customer Service team.',
    description: 'Note in the modal confirming a customer is reopening their closed Société account, telling them only customer service can close it again',
  })

  const primaryActionText = intl.formatMessage({
    id: 'cviubjgCZdpyVrmFh98K',
    defaultMessage: 'Reopen account',
    description: 'Primary button text to confirm reopening a closed Société account in the confirmation modal',
  })

  const secondaryActionText = intl.formatMessage({
    id: 'TBboLVMpTDV9mdwrwVpd',
    defaultMessage: 'Cancel',
    description: 'Secondary button text to cancel reopening a closed Société account in the confirmation modal',
  })

  return (
    <Modal
      title={title}
      primaryActionText={primaryActionText}
      secondaryActionText={secondaryActionText}
      onPrimaryActionClick={confirm}
      onSecondaryActionClick={cancel}
    >
      <Group direction="vertical" gap={16}>
        <BodyText variant="large">
          {body}
        </BodyText>
        <BodyText variant="large">
          {closeAgainNote}
        </BodyText>
      </Group>
    </Modal>
  )
}

export default LoyaltyReopenAccountConfirmationModal
